import ErrorMsg from 'components/ErrorMsg/ErrorMsg';

export default ErrorMsg;
